import { render, staticRenderFns } from "./MRIndex.vue?vue&type=template&id=32c2ed28"
import script from "./MRIndex.vue?vue&type=script&lang=ts"
export * from "./MRIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports